import { InputNumber, Slider } from "antd";
import styles from "../../../../styles/shared/trade-form/TradeModal.module.css";
import { useDispatch, useSelector } from "react-redux";
import React, { useEffect } from "react";
import useAssetAmount from "../../hooks/useAssetAmount";
import useCheckPortfolio from "../../hooks/useCheckPortfolio";
import { setTradeSize } from "../../../../redux/trade-form/tradeFormSlice";
import LimitOrderTriggerPrice from "./LimitOrderTriggerPrice";
import SetLimitForBuyOrder from "./SetLimitForBuyOrder";
import ApplyAiSuggestion from "../ApplyAiSuggestion";
import useCheckOrderLimits from "../../hooks/useCheckOrderLimits";
import { roundToPrecision } from "../../utils/helper";
import SectionLabel from "../SectionLabel";
import useAmountLimits from "../../hooks/useAmountLimits";

function SetTradeAmount() {
  const {
    tradeForm: {
      tradeType,
      tradeNativeAmount = "",
      tradeUsdAmount = "",
      assetPrice,
      finalTradeType,
      tradeAmountPercentage,
    },
  } = useSelector((state) => state);

  const { nativeAmount, usdAmount, isAssetInPortfolio } = useAssetAmount();
  const { budget } = useCheckPortfolio();

  const { amountPrecision } = useCheckOrderLimits();

  console.log(tradeNativeAmount, tradeUsdAmount, usdAmount);

  const {
    disableTrade,
    sliderStep,
    maximumSlider,
    minimumSlider,
    usdInputStep,
    maximumUsd,
    minimumUsd,
    maximumNativeInput,
    minimumNativeInput,
    nativeInputStep,
    averageNativeRange,
    averageUsdRange,
    averageSliderRange,
  } = useAmountLimits();

  // const maximumUsd =
  //   tradeType === "buy"
  //     ? +budget
  //     : // * 0.9999
  //       nativeAmount * assetPrice;

  const showLimitSettings =
    finalTradeType !== "sell" && finalTradeType !== "buy";

  // const errorMessage = disableTrade
  //   ? "You have not enough balance for trade this coin"
  //   : "";

  const dispatch = useDispatch();

  const changeNativeAmount = (value) => {
    if (
      (tradeType === "sell" && value > Number(nativeAmount)) ||
      (tradeType === "buy" && value > budget / assetPrice)
      // * 0.9999
    )
      return;

    // if (tradeType === "sell") {
    //   setSliderValue((value / nativeAmount) * 100);
    // } else {
    //   setSliderValue(((value * assetPrice) / budget) * 100);
    // }

    const percentage =
      tradeType === "sell"
        ? (value / nativeAmount) * 100
        : ((value * assetPrice) / budget) * 100;

    dispatch(
      setTradeSize(
        roundToPrecision(value, amountPrecision, averageNativeRange),
        // value,
        roundToPrecision(value * assetPrice, 0.01, averageUsdRange),
        percentage,
      ),
    );
  };

  const changeUsdAmount = (value) => {
    if (
      (tradeType === "buy" && value > budget) ||
      (tradeType === "sell" && value > usdAmount)
    )
      return;

    // if (tradeType === "sell") {
    //   const percentage = ((value * 100) / nativeAmount) * assetPrice;
    //   setSliderValue(percentage);
    // } else {
    //   const percentage = (value * 100) / budget;
    //   setSliderValue(percentage);
    // }

    const percentage =
      tradeType === "sell"
        ? ((value * 100) / nativeAmount) * assetPrice
        : (value * 100) / budget;

    dispatch(
      setTradeSize(
        roundToPrecision(
          value / assetPrice,
          amountPrecision,
          averageNativeRange,
        ),
        roundToPrecision(value, 0.01, averageUsdRange),
        // value,
        percentage,
      ),
    );
  };

  const changeSliderValue = (value) => {
    if (!value) {
      return assetPrice
        ? tradeType === "sell"
          ? (100.001 / assetPrice) * nativeAmount
          : 100.001 / budget
        : 0.001;
    } else {
      // setSliderValue(value);
      const percentage = value / 100;
      if (tradeType === "sell") {
        const native = nativeAmount * percentage;
        dispatch(
          setTradeSize(
            roundToPrecision(native, amountPrecision, averageNativeRange),
            // native,
            roundToPrecision(native * assetPrice, 0.01, averageUsdRange),
            value,
          ),
        );
      } else {
        const usd = budget * percentage;
        dispatch(
          setTradeSize(
            roundToPrecision(
              usd / assetPrice,
              amountPrecision,
              averageNativeRange,
            ),
            // usd / assetPrice,
            roundToPrecision(usd, 0.01, averageUsdRange),
            value,
          ),
        );
      }
    }
  };

  useEffect(() => {
    // if (assetPrice && !tradeNativeAmount && !tradeUsdAmount) {
    if (assetPrice) {
      const percentage = tradeAmountPercentage / 100;
      // const percentage = sliderValue / 100;
      if (tradeType === "sell") {
        const nativeValue = nativeAmount * percentage;
        dispatch(
          setTradeSize(
            roundToPrecision(nativeValue, amountPrecision, averageNativeRange),
            // nativeValue,
            roundToPrecision(nativeValue * assetPrice, 0.01, averageUsdRange),
            tradeAmountPercentage,
          ),
        );
      }
      if (tradeType === "buy") {
        const usd = budget * percentage;
        dispatch(
          setTradeSize(
            roundToPrecision(
              usd / assetPrice,
              amountPrecision,
              averageNativeRange,
            ),
            // usd / assetPrice,
            roundToPrecision(usd, 0.01, averageUsdRange),
            tradeAmountPercentage,
          ),
        );
      }
    }
  }, [
    amountPrecision,
    assetPrice,
    averageNativeRange,
    averageUsdRange,
    budget,
    dispatch,
    nativeAmount,
    tradeAmountPercentage,
    tradeType,
  ]);

  return (
    <div className={styles.setAmountBox}>
      {(tradeType !== "sell" || isAssetInPortfolio) && (
        <>
          <SectionLabel label="Amount" style={{ marginBottom: "1rem" }}>
            <ApplyAiSuggestion field="tradeAmount" />
          </SectionLabel>
          <div className={styles.amountInputs}>
            <div className={styles.inputBox}>
              <label htmlFor="amountInput">Native</label>
              <InputNumber
                value={tradeNativeAmount}
                disabled={!assetPrice}
                max={maximumNativeInput}
                min={minimumNativeInput}
                step={nativeInputStep}
                onChange={changeNativeAmount}
                status={disableTrade ? "error" : ""}
              />
            </div>
            <div className={styles.inputBox}>
              <label htmlFor="amountInput">USD:</label>
              <InputNumber
                value={tradeUsdAmount}
                disabled={!assetPrice}
                onChange={changeUsdAmount}
                max={maximumUsd}
                min={minimumUsd}
                step={usdInputStep}
                formatter={(value) => `${parseFloat(value)?.toFixed(2)}`}
                status={disableTrade ? "error" : ""}
              />
            </div>
          </div>
          {disableTrade && (
            <p style={{ fontSize: "12px", color: "red" }}>
              You have not enough balance for trade this coin
            </p>
          )}

          <div className={styles.sliderBox}>
            <Slider
              disabled={!assetPrice}
              value={tradeAmountPercentage}
              onChange={changeSliderValue}
              max={maximumSlider}
              min={minimumSlider}
              step={sliderStep}
              tooltip={{
                formatter: (value) => `${parseFloat(value)?.toFixed(2)}%`,
                placement: "bottom",
              }}
            />
            <InputNumber
              disabled={!assetPrice}
              value={tradeAmountPercentage}
              onChange={changeSliderValue}
              max={maximumSlider}
              min={minimumSlider}
              step={sliderStep}
              formatter={(value) => `${parseFloat(value)?.toFixed(2)}%`}
              parser={(value) => value.replace("%", "")}
              status={disableTrade ? "error" : ""}
            />
          </div>
        </>
      )}

      {showLimitSettings && (
        <>
          <SectionLabel
            label="Trigger Price"
            style={{ marginBottom: ".5rem" }}
          />
          <LimitOrderTriggerPrice
            limitType={
              finalTradeType === "sell_sl" || finalTradeType === "buy_db"
                ? "low"
                : finalTradeType === "buy_bb" || finalTradeType === "sell_tp"
                  ? "high"
                  : ""
            }
          />
        </>
      )}
      <SetLimitForBuyOrder />

      {!assetPrice && <div className={styles.overlayMask}></div>}
    </div>
  );
}

export default SetTradeAmount;
